import {
  all,
  call,
  fork,
  put,
  take,
  takeLatest,
} from 'redux-saga/effects';

import Api from 'api/buyer-agreements';
import { getBuyerAgreementTemplate } from 'store/actions/buyer-agreement-template-actions';

function* ensureGetBuyerAgreementTemplate({ payload }) {
  let resolve;
  let reject;
  if (payload) {
    ({ resolve, reject } = payload);
  }
  try {
    const { data } = yield call(Api.getBuyerAgreementTemplate);
    yield put({
      type: getBuyerAgreementTemplate.success,
      payload: {
        document: data.content,
        version: data.updatedAt,
      },
    });
    if (resolve) {
      resolve(data);
    }
  } catch (err) {
    yield put({
      type: getBuyerAgreementTemplate.failure,
      err,
    });
    if (reject) {
      reject(err);
    }
  }
}

function* watchGetBuyerAgreementTemplate() {
  yield takeLatest(getBuyerAgreementTemplate.type, ensureGetBuyerAgreementTemplate);
  yield take(getBuyerAgreementTemplate.success);
}

export default function* buyerAgreementTemplateSagas() {
  yield all([
    fork(watchGetBuyerAgreementTemplate),
  ]);
}
